module.exports = __webpack_public_path__ + "static/media/icon.984f07c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/icon.png
// module id = 767
// module chunks = 0